import api from '../utils/api';

class AuthApi {
  verifyTotpLogin = (data) => {
    return api.post('/v1/auth/login/verify-totp', data);
  };

  loginSetupTotp = (data) => {
    return api.post('/v1/auth/login/setup-totp', data);
  };

  loginEnableTotp = (data) => {
    return api.post('/v1/auth/login/enable-totp', data);
  };

  get2FAStatus = () => {
    return api.get('/v1/auth/totp/status');
  };

  setup2FA = () => {
    return api.post('/v1/auth/totp/setup');
  };

  enable2FA = (data) => {
    return api.post('/v1/auth/totp/enable', data);
  };

  disable2FA = (data) => {
    return api.post('/v1/auth/totp/disable', data);
  };

  reset2FA = (data) => {
    return api.post('/v1/auth/totp/reset', data);
  };

  // Kept for restore: Admin 2FA page hides assign UI (SHOW_ASSIGN_2FA=false).
  // Policy: all admin-dashboard accounts must use 2FA at login.
  assign2FA = (data) => {
    return api.post('/v1/auth/totp/assign', data);
  };
}

const authApi = new AuthApi();
export default authApi;
